module.exports = __webpack_public_path__ + "static/img/info-ADVANTAGES-internships-career-services.5b99cf9.png";


//////////////////
// WEBPACK FOOTER
// ./static/info-ADVANTAGES-internships-career-services.png
// module id = lyf9
// module chunks = 1